<template>
  <div>
    <ContactTab v-for="item in 16" :key="item.id"/>
  </div>

</template>

<script>
import ContactTab from'../components/ContactTab.component'
export default {
  name: "ContactTabsContainer",
  components: {ContactTab}
}
</script>

<style scoped>

</style>